import { withAPIAccount } from '../../lib/http/api';
import { parsedResponse } from '../../lib/http/http';
import { AccountType, IAPIresponse } from '../../model';
import {
  IMessageItem,
  MessageStatus,
  ISystemMessageReq,
} from '../../model/api-modules/message';
import { MESSAGE_CREATE_PREFIX, MESSAGE_PREFIX } from '../config';
import { NOTICE_ALERT_IDS } from '../../pages/component/message-center/components/config';

// 消息模块-消息列表
export const getMessageList = (
  status?: MessageStatus,
  page?: number,
  pageSize?: number
) =>
  withAPIAccount(AccountType.auto, async (api) => {
    try {
      const url = `${MESSAGE_PREFIX}`;
      const response = await api.commonRequest('GET', url, {
        status,
        page,
        pageSize: pageSize || 1000,
      });
      const res = await parsedResponse<{ total: number; list: IMessageItem[] }>(
        response,
        'data',
        true
      );
      return res;
    } catch (error) {
      return null;
    }
  });

// 消息模块-创建消息
export const postMessageInfo = (body: ISystemMessageReq) =>
  withAPIAccount(AccountType.auto, async (api) => {
    try {
      const url = `${MESSAGE_CREATE_PREFIX}`;
      const response = await api.commonRequest('POST', url, body);
      const res = await parsedResponse<IAPIresponse>(response, 'data');
      return res;
    } catch (error) {
      return null;
    }
  });

const deleteLocalMessageIds = (ids: Array<number>) => {
  let localMessageIds: Array<number> = [];
  try {
    localMessageIds = JSON.parse(
      localStorage.getItem(NOTICE_ALERT_IDS) || '[]'
    );
    ids.forEach((id: number) => {
      const i = localMessageIds.indexOf(id);
      if (i !== -1) {
        localMessageIds.splice(i, 1);
      }
    });
    localStorage.setItem(NOTICE_ALERT_IDS, JSON.stringify(localMessageIds));
  } catch (error) {}
};

// 消息模块-消息查看
export const messageRed = (id: number) =>
  withAPIAccount(AccountType.auto, async (api) => {
    try {
      const url = `${MESSAGE_PREFIX}/${id}/read`;
      const response = await api.commonRequest(
        'PATCH',
        decodeURIComponent(url)
      );
      const res = await parsedResponse(response, 'data');
      if (res === 0) {
        deleteLocalMessageIds([id]);
      }
      return res === 0;
    } catch (error) {
      return false;
    }
  });

// 消息模块-消息查看(批量)
export const messageReads = (ids: number[]) =>
  withAPIAccount(AccountType.auto, async (api) => {
    try {
      const url = `${MESSAGE_PREFIX}/reads`;
      const response = await api.commonRequest('PUT', url, {
        ids,
      });
      const res = await parsedResponse(response, 'code');
      if (res === 0) {
        deleteLocalMessageIds(ids);
      }
      return res;
    } catch (error) {
      return false;
    }
  });
